import React from "react";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";

import ProductListOne from "../components/ProductListOne";
import OfferOne from "../components/OfferOne";
import BestSellsOne from "../components/BestSellsOne";
import DeliveryOne from "../components/DeliveryOne";

import ShippingOne from "../components/ShippingOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
const HomePageOne = () => {

  return (

    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#c11e23" />
      {/* #029441 */}

      {/* ColorInit */}
      <ColorInit color={false} />

 
      {/* BannerOne */}
      <BannerOne />

      {/* FeatureOne */}
      <FeatureOne />

      {/* PromotionalOne
      <PromotionalOne /> */}

  {/* OfferOne */}
      <OfferOne />

      {/* ProductListOne */}
      <ProductListOne />
<br />
      {/* BestSellsOne */}

      {/* DeliveryOne */}
      <DeliveryOne />
      <br />
      <BestSellsOne />


      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default HomePageOne;
